import { FC, ReactNode } from 'react';
import { Header, HeaderGroup } from '@tanstack/react-table';
import EmptyCell from '../EmptyCell/EmptyCell';
import HeaderTitleCell from './TitleCell/TitleCell';
import { TableSort } from '../../';
import st from "./Header.module.scss";

interface IMainTitleRowProps {
	sort?: TableSort;
	minColumnSize?: number;
	headerGroup: HeaderGroup<any>;
	renderFirstToolbar?: () => ReactNode;
};

const MainTitleRow: FC<IMainTitleRowProps> = ( props ) => {

	const { minColumnSize, renderFirstToolbar, headerGroup, sort } = props;

	/** Функция определяет последняя ли колонка */
	const isLastColumn = ( id: string ): boolean => headerGroup.headers.findIndex( c => c.id === id ) === (headerGroup.headers.length - 1);

	/** Возвращает ширину колонки  */
	const getColumnWidth = ( header: Header<any, any> ): number | "100%" => {
		const isLast = isLastColumn( header.id );
		if ( isLast ) {
			return "100%";
		}
		return header.getSize();
	};

	/** Рендер ячейки шапки таблицы  */
	const renderHeaderCell = ( header: Header<any, any> ) => (
		<HeaderTitleCell
			key={ "MainHeaderCell_" + header.id }
			header={header}
			minColumnSize={minColumnSize}
			sort={sort}
			colSpan={ isLastColumn( header.id ) ? 2 : header.colSpan }
			width={getColumnWidth(header)}
		/>
	);

	return (
		<tr key={ headerGroup.id + '_titles'} className={st.mainRow}>
			{ !!renderFirstToolbar ? renderFirstToolbar() : <EmptyCell isHeader width={32} /> }
			{ headerGroup.headers.map(renderHeaderCell) }
			<EmptyCell isHeader width={32} />
		</tr>
	);
};

export default MainTitleRow;